import { render, staticRenderFns } from "./OmbudsmanView.vue?vue&type=template&id=21da7bc8&scoped=true&"
import script from "./OmbudsmanView.vue?vue&type=script&lang=js&"
export * from "./OmbudsmanView.vue?vue&type=script&lang=js&"
import style0 from "./OmbudsmanView.vue?vue&type=style&index=0&id=21da7bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da7bc8",
  null
  
)

export default component.exports